import SimpleText, { SimpleTextProps } from "./SimpleText";
// TODO custom implementation
const MultilineText = <T,>(props: SimpleTextProps<T>) => (
  <SimpleText rows={4} {...props} multiline />
);
export default MultilineText;
